(function () {

    var jsDoubleImageSwitch = document.getElementsByClassName("js-double-image-switch");

    if (!jsDoubleImageSwitch.length)
        return;

    // loop through the elements
    for (var i = 0; i < jsDoubleImageSwitch.length; i++) {
        // grab the main element
        var elem = jsDoubleImageSwitch[i];

        var backImage = elem.children[0],
            frontImage = elem.children[1];

        // click events
        backImage.addEventListener('click', function () {
            jsSwitchAddClass(this.parentElement);
        });

        frontImage.addEventListener('click', function () {
            jsSwitchRemoveClass(this.parentElement);
        });

        // mouser over events
        backImage.addEventListener('mouseover', function () {
            jsSwitchAddClass(this.parentElement);
        });

        frontImage.addEventListener('mouseover', function () {
            jsSwitchRemoveClass(this.parentElement);
        });
    }

    function jsSwitchAddClass(elem) {
        if (elem.classList.contains('js-double-image-switch--on'))
            return;

        elem.classList.add('js-double-image-switch--on');
    }

    function jsSwitchRemoveClass(elem) {
        if (!elem.classList.contains('js-double-image-switch--on'))
            return;

        elem.classList.remove('js-double-image-switch--on');
    }

}());
